module.exports = __webpack_public_path__ + "static/post-two-a38d54c4589b174d99191657e2e6933c.png";